import React, { useEffect, useState } from "react";

import { filesystem_root, subdomain } from "../../../config";
import { jsonParser } from "../../../utils/helpers";
import slidePlaceholder from "../../../assets/16x9-placeholder.jpg";

export default function Thumbnail(props) {
  const isLibrarySlide =
    props.slide.initial_presentation === props.presentation.id ? false : true;

  const rootThumb = isLibrarySlide
    ? `${filesystem_root}/${subdomain}/presentations/${props.slide.initial_presentation}/${props.slide.initial_presentation}/thumbnails/slide_${props.slide.id}_thumbnail.jpg`
    : `${filesystem_root}/${subdomain}/slides/${props.slide.id}/slide_${props.slide.id}_thumbnail.jpg`;

  const bespoke = jsonParser(props.slide.slide_json)?.reveal?.slideThumbnail
    ?.field_media_image;

  // Use the mtime from the server-side status endpoint as the cache key.
  // Stable URL → browser caches indefinitely; URL changes only when the
  // file on disk actually changes.
  const src = bespoke
    ? bespoke
    : props.version
    ? `${rootThumb}?v=${props.version}`
    : rootThumb;

  const [errored, setErrored] = useState(false);

  useEffect(() => {
    setErrored(false);
  }, [src]);

  if (errored) {
    return (
      <div className="no-thumb" data-thumb={src}>
        <img
          src={slidePlaceholder}
          alt="No thumbnail placeholder"
          loading="lazy"
        />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt=""
      loading="lazy"
      onError={() => setErrored(true)}
    />
  );
}
